export default __webpack_public_path__ + "static/media/edwin.c1d2100c.png";